<div class="row g-3 justify-content-center">
  <div class="col-md-2 col-sm-4 col-6">
    <div class="card rounded-4 shadow-sm">
      <div class="mb-2">
        <div
          class="card-body d-flex align-items-center justify-content-between"
          >
          <div>
            <h3 class="fw-bold mb-0">
              {{ getSumOfAllLoadings().sumOfDailyLoading }}
            </h3>
            <h6 class="text-muted font-weight-bold mb-1">برداشت روزانه</h6>
          </div>
          <div
            class="rounded-circle d-flex align-items-center justify-content-center me-3 bg-yellowbox card-logo"
            >
            <i class="fas fa-calendar-day fs-4"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2 col-sm-4 col-6">
    <div class="card rounded-4 shadow-sm">
      <div class="mb-2">
        <div
          class="card-body d-flex align-items-center justify-content-between"
          >
          <div>
            <h3 class="fw-bold mb-0">{{ getSumOfAllLoadings().average }}</h3>
            <h6 class="text-muted mb-1">متوسط برداشت</h6>
          </div>
          <div
            class="rounded-circle d-flex align-items-center justify-content-center me-3 card-logo bg-primary"
            >
            <i class="fas fa-chart-bar fs-4"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2 col-sm-4 col-6">
    <div class="card rounded-4 shadow-sm">
      <div class="mb-2">
        <div
          class="card-body d-flex align-items-center justify-content-between"
          >
          <div>
            <h3 class="fw-bold mb-0">
              {{ getSumOfAllLoadings().sumOfLoading }}
            </h3>
            <h6 class="text-muted mb-1">جمع برداشت</h6>
          </div>
          <div
            class="rounded-circle d-flex align-items-center justify-content-center me-3 card-logo bg-redbox"
            >
            <i class="fas fa-layer-group fs-4"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2 col-sm-4 col-6">
    <div class="card rounded-4 shadow-sm">
      <div class="mb-2">
        <div
          class="card-body d-flex align-items-center justify-content-between"
          >
          <div>
            <h3 class="fw-bold mb-0">
              {{ getSumOfAllLoadings().sumOfEstimate }}
            </h3>
            <h6 class="text-muted mb-1">تخمین آخر ماه</h6>
          </div>
          <div
            class="rounded-circle d-flex align-items-center justify-content-center me-3 card-logo bg-info"
            >
            <i class="fas fa-chart-line fs-4"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2 col-sm-4 col-6">
    <div class="card rounded-4 shadow-sm">
      <div class="mb-2">
        <div
          class="card-body d-flex align-items-center justify-content-between"
          >
          <div>
            <h3 class="fw-bold mb-0">{{ getSumOfSolds() }}</h3>
            <h6 class="text-muted mb-1">فروش ماهانه</h6>
          </div>
          <div
            class="rounded-circle d-flex align-items-center justify-content-center me-3 card-logo bg-navy"
            >
            <i class="fas fa-store fs-4"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2 col-sm-4 col-6">
    <div class="card rounded-4 shadow-sm">
      <div class="mb-2">
        <div
          class="card-body d-flex align-items-center justify-content-between"
          >
          <div>
            <h3 class="fw-bold mb-0">{{ getSumOfAllLoadings().payments }}</h3>
            <h6 class="text-muted mb-1">مجموع مانده حواله</h6>
          </div>
          <div
            class="rounded-circle d-flex align-items-center justify-content-center me-3 card-logo bg-bluebox"
            >
            <i class="fas fa-calculator fs-4"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row g-4">
  <div class="col-md-6">
    @for (organisation of reports; track $index) {
      <div>
        <div class="card shadow-sm rounded-4">
          <div
            class="card-header bg-table text-white rounded-3 d-flex justify-content-between"
            >
            <div class="fw-bold">
              مانده ریالی : {{ organisation.paymentBalances }}
            </div>
            <div class="fw-bold">
              برداشت شرکت {{ organisationFormatter(organisation.organisation) }}
            </div>
          </div>
          <div class="card-body">
            <div>
              <table
                class="table table-sm table-hover table-bordered text-center"
                >
                <thead class="bs-dark-bg-subtle">
                  <tr>
                    <th>مبدا</th>
                    <th>سهمیه ماه</th>
                    <th>سهمیه تا این تاریخ</th>
                    <th>بارگیری روزانه</th>
                    <th>مجموع بارگیری</th>
                    <th>تعادل</th>
                    <th>تخمین آخر ماه</th>
                  </tr>
                </thead>
                <tbody>
                  @for (loading of organisation.loadings; track $index) {
                    <tr>
                      <td>
                        {{ organisationFormatter(loading.sourceOrganisationId) }}
                      </td>
                      <td>{{ loading.quota | number }}</td>
                      <td>{{ loading.quotaToDate | number }}</td>
                      <td>{{ loading.selectedDayLoading | number }}</td>
                      <td>{{ loading.total | number }}</td>
                      <td>{{ loading.balance | number }}</td>
                      <td>{{ loading.estimate | number }}</td>
                    </tr>
                  }
                  <tr class="bg-light">
                    <td class="fw-bold">مجموع</td>
                    <td>
                      {{
                      getSumOfLoadings(organisation.loadings).sumOfQuota
                      | number
                      }}
                    </td>
                    <td>
                      {{
                      getSumOfLoadings(organisation.loadings).sumOfQuotaToDate
                      | number
                      }}
                    </td>
                    <td>
                      {{
                      getSumOfLoadings(organisation.loadings).sumOfDailyLoading
                      | number
                      }}
                    </td>
                    <td>
                      {{
                      getSumOfLoadings(organisation.loadings).sumOfLoading
                      | number
                      }}
                    </td>
                    <td>
                      {{
                      getSumOfLoadings(organisation.loadings).sumOfbalance
                      | number
                      }}
                    </td>
                    <td>
                      {{
                      getSumOfLoadings(organisation.loadings).sumOfEstimate
                      | number
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="col-md-6">
    @for (discharge of reports; track $index) {
      <div>
        <div class="card shadow-sm rounded-4">
          <div
            class="card-header bg-table text-white rounded-3 d-flex justify-content-end"
            >
            <div class="fw-bold">
              تخلیه در تاسیسات {{ organisationFormatter(discharge.organisation) }}
            </div>
          </div>
          <div class="card-body col-md-12">
            <table class="table table-sm table-hover table-bordered text-center">
              <thead class="bs-dark-bg-subtle">
                <tr class="fw-bold">
                  <td>مقصد</td>
                  <td>سهمیه ماه</td>
                  <td>سهمیه تا این تاریخ</td>
                  <td>بارگیری روزانه</td>
                  <td>فروش</td>
                  <td>مجموع فروش</td>
                  <td>موجودی</td>
                  <td>مجموع بارگیری</td>
                  <td>تعادل</td>
                  <td>تخمین آخر ماه</td>
                </tr>
              </thead>
              <tbody>
                @for (discharge of discharge.discharges; track $index) {
                  <tr>
                    <td>
                      {{
                      organisationFormatter(discharge.destinationOrganisationId)
                      }}
                    </td>
                    <td>{{ discharge.quota | number }}</td>
                    <td>{{ discharge.quotaToDate | number }}</td>
                    <td>{{ discharge.selectedDayDischarge | number }}</td>
                    <td>{{ discharge.sold | number }}</td>
                    <td>{{ discharge.sumOfSold | number }}</td>
                    <td>{{ discharge.stored | number }}</td>
                    <td>{{ discharge.total | number }}</td>
                    <td>{{ discharge.balance | number }}</td>
                    <td>{{ discharge.estimate | number }}</td>
                  </tr>
                }
                <tr class="bg-light">
                  <td class="fw-bold">مجموع</td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfQuota | number
                    }}
                  </td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfQuotaToDate
                    | number
                    }}
                  </td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfDailyLoading
                    | number
                    }}
                  </td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfSold | number
                    }}
                  </td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfSolds | number
                    }}
                  </td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfStored | number
                    }}
                  </td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfLoading
                    | number
                    }}
                  </td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfLoadingbalance
                    | number
                    }}
                  </td>
                  <td>
                    {{
                    getSumOfDischarge(discharge.discharges).sumOfEstimate
                    | number
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  </div>
</div>
